import * as React from "react";
const SvgWishlistHeader = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 14"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.81796 3.13055C6.21429 -0.633601 0.601472 -0.232685 0.601472 4.57833C0.601472 9.38934 7.81796 13.3986 7.81796 13.3986C7.81796 13.3986 15.0344 9.38934 15.0344 4.57833C15.0344 -0.232685 9.42162 -0.633601 7.81796 3.13055Z"
    />
  </svg>
);
export default SvgWishlistHeader;
